import React from 'react';
import { Button } from 'react-bootstrap';
const slbProps = {
    id:'',
    varient:'',
    onClick:null,
    className:'',
    type:'',
    disabled: false
}
function SlbButton( props=slbProps ) {

    
    return (
        <span className='PrimaryBtn'>
            <Button id={props.id}
            disabled = {props.disabled}
                variant={props.variant}
                onClick={props.onClick}
                className={props.className}
                color={props.color || 'primary'}
                type={props.type}
            >
                {props.children}
            </Button>
        </span>
    )
}
export default SlbButton;